export const btlObjectiveProductSchema = {
	schema: {
		title: 'btl objective product schema',
		description: 'BTL Objective Product Schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			product_id: {
				type: 'number',
			},
			product_sfid: {
				type: 'string',
			},
			prdgroup3_c: {
				type: 'string',
			},
			productgroup2description_c: {
				type: 'string',
			},
			meetingmodule_c: {
				type: 'string',
			},
			btl_objective_c: {
				type: 'string',
			},
		},
		required: [
			'id',
			'product_id',
			'product_sfid',
			'prdgroup3_c',
			'productgroup2description_c',
			'meetingmodule_c',
			'btl_objective_c',
		],
	},
};
